import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { api } from '../consts/url';
import { ProjectAddonModel } from '../store/models/project-addon.model';

@Injectable({ providedIn: 'root' })
export class ProjectAddonService {
  constructor(private readonly http: HttpClient) { }

  public getAddonTypes(): Observable<ProjectAddonModel.API.AddonTypeResponse[]> {
    return this.http.get<ProjectAddonModel.API.AddonTypeResponse[]>(
      api.project.addon.types,
    );
  }

  public findAllByProjectId(
    projectId: string,
    params: ProjectAddonModel.API.GetAddonsParamsDto = {},
  ): Observable<ProjectAddonModel.AddonDocument[]> {
    const requestParams: Record<string, string> = {};

    if (params.target) {
      requestParams['target'] = params.target;
    }

    return this.http.get<ProjectAddonModel.AddonDocument[]>(
      api.project.addon.crud(projectId),
      { params: requestParams },
    );
  }

  public create(
    projectId: string,
    locationId: string,
    addon: ProjectAddonModel.API.CreateAddonDto,
  ): Observable<ProjectAddonModel.AddonDocument> {
    return this.http.post<ProjectAddonModel.AddonDocument>(
      api.project.addon.create(projectId, locationId),
      { ...addon }
    );
  }

  public update(
    addonId: string,
    addon: Partial<ProjectAddonModel.API.CreateAddonDto>,
  ): Observable<ProjectAddonModel.AddonDocument> {
    return this.http.put<ProjectAddonModel.AddonDocument>(
      api.project.addon.update(addonId),
      { ...addon }
    );
  }

  public bulkCreate(
    projectId: string,
    addons: ProjectAddonModel.API.BulkCreateDto,
  ): Observable<ProjectAddonModel.AddonDocument[]> {
    return this.http.post<ProjectAddonModel.AddonDocument[]>(
      api.project.addon.bulkCreate(projectId),
      { ...addons }
    );
  }

  public bulkUpdate(
    projectId: string,
    addons: ProjectAddonModel.API.BulkUpdateDto,
  ): Observable<ProjectAddonModel.AddonDocument[]> {
    return this.http.put<ProjectAddonModel.AddonDocument[]>(
      api.project.addon.bulkUpdate(projectId),
      { ...addons },
    );
  }

  public bulkDelete(
    projectId: string,
    addonIds: string[],
  ): Observable<boolean> {
    return this.http.delete<boolean>(
      api.project.addon.bulkDelete(projectId),
      {
        body: {
          addonIds,
        },
      },
    );
  }
}
